import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const LandingNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-deepspace/95 backdrop-blur-lg shadow-lg shadow-cyber-blue/10' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          
          <Link to="/" className="flex items-center space-x-3 animate-slide-down">
            <img 
              src="/images/logos/aureumvault-light-logo.png" 
              alt="AureumVault Logo" 
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-text-secondary hover:text-cyber-blue transition-all duration-300 hover:scale-105">Home</Link>
            <Link to="/features" className="text-text-secondary hover:text-cyber-blue transition-all duration-300 hover:scale-105">Features</Link>
            <Link to="/security" className="text-text-secondary hover:text-cyber-blue transition-all duration-300 hover:scale-105">Security</Link>
            <Link to="/how-it-works" className="text-text-secondary hover:text-cyber-blue transition-all duration-300 hover:scale-105">How It Works</Link>
            <Link to="/about" className="text-text-secondary hover:text-cyber-blue transition-all duration-300 hover:scale-105">About</Link>
            
            <Link 
              to="/auth" 
              className="px-6 py-3 bg-gradient-cyber text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-cyber-blue/50 transition-all duration-300 hover:scale-105 animate-glow"
            >
              Connect Wallet
            </Link>
          </div>

          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-text-primary hover:text-cyber-blue transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-deepspace-500 backdrop-blur-lg border-t border-dark-border shadow-2xl">
          <div className="px-4 py-6 space-y-4">
            <Link to="/" className="block text-text-secondary hover:text-cyber-blue transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/features" className="block text-text-secondary hover:text-cyber-blue transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Features</Link>
            <Link to="/security" className="block text-text-secondary hover:text-cyber-blue transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Security</Link>
            <Link to="/how-it-works" className="block text-text-secondary hover:text-cyber-blue transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>How It Works</Link>
            <Link to="/about" className="block text-text-secondary hover:text-cyber-blue transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link 
              to="/auth" 
              className="block w-full px-6 py-3 bg-gradient-cyber text-white rounded-lg font-semibold text-center hover:shadow-lg hover:shadow-cyber-blue/50 transition-all duration-300"
              onClick={() => setMobileMenuOpen(false)}
            >
              Connect Wallet
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;

